import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Role = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom?.grey?.main,
  marginTop: "2px",
  fontSize: "13px",
  lineHeight: "24px",
}));
